import { Image } from '@storyofams/storyblok-toolkit';
import { getLinkProps } from '~/lib';
import { Heading } from '../Heading';
import { PlayIcon } from '../Icons';
import { Link } from '../Link';

export const HighlightBanner = ({
  url,
  content,
  image,
  subtext,
  cta,
}: {
  url?: any;
  content?: any;
  image?: any;
  subtext?: string;
  cta?: string;
}) => {
  return (
    <div className="w-full block pt-20">
      <div className="w-full max-w-6xl px-4 mx-auto rounded-2xl overflow-hidden">
        <Link href={getLinkProps(url)}>
          <a className="w-full h-[464px] overflow-hidden rounded-2xl object-center relative p-5 md:p-14 flex flex-col justify-end lg:justify-between">
            {(!!image?.filename || !!content?.image?.filename) && (
              <div className="absolute inset-0 h-full w-full">
                <Image
                  src={image?.filename || content?.image?.filename}
                  alt={image?.alt || content?.image?.alt}
                  fit="cover"
                  width="100%"
                  height="100%"
                  className="rounded-2xl"
                />
              </div>
            )}
            <div className="absolute inset-0 bg-gradient-to-r from-black" />

            <div className="text-white relative z-20 max-w-[420px]">
              {!!content?.kicker && (
                <div className="uppercase mb-2 sm:mb-7 text-sm">
                  {content.kicker}
                </div>
              )}

              {!!content?.title && (
                <Heading
                  as="h3"
                  variant="h3"
                  className="text-white !font-medium leading-[110%] !text-2xl lg:!text-5xl"
                >
                  {content.title}
                </Heading>
              )}

              {!!subtext && (
                <div className="text-lg mt-2 md:mt-6">{subtext}</div>
              )}
            </div>

            <div className="flex items-center space-x-4 relative z-20 mt-2 lg:mt-0">
              <div className="bg-yellow-500 rounded-full aspect-1 w-12 flex items-center justify-center">
                <PlayIcon className="w-4 relative left-0.5" />
              </div>
              <div className="text-yellow-500 text-sm">
                {cta || 'Watch now'}
              </div>
            </div>
          </a>
        </Link>
      </div>
    </div>
  );
};
